"use client";
import { useHover, useHoverDirty } from "react-use";
import SearchNormalIcon from "@/app/_components/Icons/SearchNormalIcon";
import { Search } from "@mui/icons-material";
import {
  Backdrop,
  Box,
  ClickAwayListener,
  Fade,
  IconButton,
  InputAdornment,
  Popover,
  styled,
  SwipeableDrawer,
  TextField,
  Typography,
} from "@mui/material";
import React, { useDeferredValue, useState } from "react";
import { useDebounce } from "use-debounce";
import SearchContent from "@/app/(main)/_components/SearchContent";
import { useBreakPoints } from "@/lib/useBreakPoints";

export default function SearchInput(props: { open: boolean; onClose: () => void; onOpen: () => void }) {
  const { onOpen, open, onClose } = props;

  const { mdAndDown } = useBreakPoints();

  const ref = React.useRef(null);
  const hovered = useHoverDirty(ref);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    onOpen();
  };

  const handleClose = () => {
    setAnchorEl(null);
    onClose();
  };
  const [deferredAnchorEl] = useDebounce(anchorEl, 500);

  const openedMenu = Boolean(anchorEl);

  const id = open ? "search-popper" : undefined;
  const width = anchorEl?.getBoundingClientRect().width;
  const [deferredWidth] = useDebounce(width, 500);

  return (
    <>
      {/*<ClickAwayListener onClickAway={handleClose}>*/}
      <Box
        ref={ref}
        onClick={handleOpen}
        aria-describedby={id}
        sx={(theme) => ({
          position: "relative",
          height: "100%",
          width: "100%",
          borderRadius: { xs: 8, md: 3 },
          border: 1,
          borderColor: openedMenu ? "transparent" : hovered ? "grey.200" : "transparent",
          backgroundColor: openedMenu ? "white" : `${theme.palette.grey["50"]} !important`,
        })}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: 50,
            transform: "translateY(-50%)", // Center vertically
            display: "block",
            transition: "0.2s",
            zIndex: 1,
            color: "grey.400",
            pointerEvents: "none",
          }}
        >
          <Typography variant="body2">
            جستجوی کالا در <Box component={"strong"}>زیباسی </Box>
          </Typography>
        </Box>
        <TextField
          fullWidth
          name="search-placeholder"
          label=""
          aria-label="search-placeholder"
          placeholder={" "}
          variant="standard"
          sx={(theme) => ({
            "& .MuiInputBase-root": {
              // backgroundColor: `${theme.palette.grey["50"]} !important`,
              // borderRadius: theme.spacing(2),
              height: 56,
              [theme.breakpoints.down("md")]: {
                // borderRadius: `${theme.spacing(200)} !important`,
                height: 42,
              },
            },
          })}
          InputProps={{
            readOnly: true,
            disableUnderline: true,
            inputProps: {
              "aria-labelledby": "search-placeholder",
              "aria-label": "search-placeholder",
              "aria-describedby": "search-placeholder",
            },
            startAdornment: (
              <InputAdornment
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minWidth: 40,
                  pointerEvents: "none",
                }}
                position="start"
              >
                <SearchNormalIcon />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      {!mdAndDown ? (
        <Popover
          id={id}
          open={openedMenu}
          anchorEl={deferredAnchorEl || anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          TransitionComponent={Fade} // اضافه کردن Transition
          keepMounted={false}
          TransitionProps={
            {
              // onExit: handleClose,
            }
          }
          slotProps={{
            paper: {
              sx: (theme) => ({
                width: deferredWidth || width || "auto",
                boxShadow: "none",
                border: `1px solid ${theme.palette.grey["400"]}`,
                borderRadius: 3,
              }),
            },
          }}
        >
          <SearchContent onSelect={handleClose} />
        </Popover>
      ) : (
        <SwipeableDrawer
          ModalProps={{
            keepMounted: false,
          }}
          PaperProps={{
            sx: {
              height: "100%",
              // borderTopLeftRadius: 4 * 4,
              // borderTopRightRadius: 4 * 4,
            },
          }}
          anchor={"bottom"}
          open={open}
          onClose={() => {
            handleClose();
          }}
          onOpen={() => {}}
          disableDiscovery={true}
          hysteresis={0}
          disableSwipeToOpen={true}
          swipeAreaWidth={0}
        >
          <SearchContent onSelect={handleClose} />
        </SwipeableDrawer>
      )}
      {/*</ClickAwayListener>*/}
    </>
  );
}
